export default [
  {
    path: '/app/survey',
    name: 'Anamnese',
    meta: { layout: 'app', title: 'Kur + Reha App - Anamnese Fragebogen' },
    component: () => import('@/views/anamnese/Survey.vue'),
  },
]
